Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStyles = void 0;
const get_responsive_prop_1 = require("./lib/get-responsive-prop");
const parse_prop_1 = require("./lib/parse-prop");
const recursiveParse = ({ config, theme, props, result }) => {
    for (const name of Object.keys(props)) {
        if (typeof props[name] === 'object' &&
            props[name] !== null &&
            !Array.isArray(props[name])) {
            result[name] = {};
            recursiveParse({
                config,
                props: props[name],
                result: result[name],
                theme,
            });
            continue;
        }
        if (name in config.propertyAliases) {
            config.propertyAliases[name].forEach((fullPropName) => {
                const propWithMediaQueries = parse_prop_1.parseProp({
                    config,
                    name: fullPropName,
                    theme,
                    value: props[name],
                });
                get_responsive_prop_1.mergeInMediaQuery({ result, propWithMediaQueries });
            });
        }
        else {
            const propWithMediaQueries = parse_prop_1.parseProp({
                config,
                name,
                theme,
                value: props[name],
            });
            get_responsive_prop_1.mergeInMediaQuery({ result, propWithMediaQueries });
        }
    }
};
exports.parseStyles = ({ config, theme, props }) => {
    const result = {};
    recursiveParse({ config, theme, props, result });
    return result;
};
//# sourceMappingURL=parse-styles.js.map